import { useEffect } from "react";
import { Outlet, Route, Routes } from "react-router-dom";
import { toAbsoluteUrl } from "_metronic/helpers";

const AuthLayout = () => {
  useEffect(() => {
    document.body.classList.add("bg-white");
    return () => {
      document.body.classList.remove("bg-white");
    };
  }, []);

  return (
    <div className="d-flex flex-column flex-column-fluid bgi-position-y-bottom position-x-center bgi-no-repeat bgi-size-contain bgi-attachment-fixed">
      {/* begin::Content */}
      <div className="d-flex flex-center flex-column flex-column-fluid p-10 pb-lg-20">
        {/* begin::Logo */}
        <a data-test-id="maintenance-page__logo-link" href="#" className="mb-12">
          <img alt="Logo" src={toAbsoluteUrl("/proptimo.svg")} className="proptimo-logo-large" />
        </a>
        {/* end::Logo */}
        {/* begin::Wrapper */}
        <div className="w-lg-500px bg-white rounded shadow-sm p-10 p-lg-15 mx-auto">
          <Outlet />
        </div>
        {/* end::Wrapper */}
      </div>
      {/* end::Content */}
      {/* begin::Footer */}
      <div className="d-flex flex-center flex-column-auto p-10">
        <div className="d-flex align-items-center fw-bold fs-6">
          <a data-test-id="maintenance-page__about-link" href="#" className="text-muted text-hover-primary px-2">
            About
          </a>

          <a data-test-id="maintenance-page__contact-link" href="#" className="text-muted text-hover-primary px-2">
            Contact
          </a>
        </div>
      </div>
      {/* end::Footer */}
    </div>
  );
};

const MaintenancePage: React.FC = () => {
  return (
    <Routes>
      <Route element={<AuthLayout />}>
        <Route
          index
          element={
            <div className="alert alert-primary d-flex align-items-center p-5">
              <div className="d-flex flex-column">
                <h5 className="mb-1">Maintenance in progress</h5>
                <span>
                  Connect is currently under maintenance. Please try again later. We apologise for any inconvenience
                </span>
              </div>
            </div>
          }
        />
      </Route>
    </Routes>
  );
};

export default MaintenancePage;
